import { defineComponent, type FunctionalComponent } from 'vue'
import type { IFormErrorMessageProps } from './types'
import type { FormError } from '../validation'
import SpeechBubble from 'components/speech-bubble'
import Bubbletip from 'components/bubbletip'

type FormErrorItemProps = Partial<IFormErrorMessageProps> & {
  error: FormError
}

const FormErrorItem: FunctionalComponent<FormErrorItemProps> = (props) => {
  return (
    <div class="text-sm flex items-center content-center align-center">
      {props.error.message || 'Unknown Error'}
    </div>
  )

  return (
    <SpeechBubble placement={props.placement}>
      {props.error.message || 'Unknown error'}
    </SpeechBubble>
  )
  //return (
  //  <div
  //    class="text-gray-900 text-red-500 px-2 py-2 text-xs"
  //    style={{
  //      width: '100%',
  //      minHeight: '1.5rem'
  //    }}
  //  >
  //    <p>{props.error.message || 'Unknown error'}</p>
  //  </div>
  //)
}

const FormErrorMessage = defineComponent<IFormErrorMessageProps>({
  name: 'FormErrorMessage',
  setup(props) {
    return () => {
      return (
        <Bubbletip
          placement={props.placement || 'left'}
          variant="white"
          noMouseEvents
          body={() => {
            return (
              <div>
                {(props.errors || []).map((err) => (
                  <FormErrorItem error={err} placement={props.placement} />
                ))}
              </div>
            )
          }}
          triggerRef={props.anchor}
          visible={props.errors && props.errors.length > 0}
        />
      )
      //  return (
      //    <div>
      //      {(props.errors || []).map((err) => (
      //        <FormErrorItem error={err} placement={props.placement} />
      //      ))}
      //    </div>
      //  )
    }
  }
})

FormErrorMessage.props = ['errors', 'placement', 'anchor']
export default FormErrorMessage
